import { Checkbox, FormControlLabel } from '@mui/material';
import React from 'react';
import { ControllerRenderProps, FieldValues } from 'react-hook-form';

type Props = ControllerRenderProps<FieldValues, string> & {
  label: React.ReactNode;
  defaultChecked?: boolean;
};

function UiCheckBox({ label, ...rest }: Props) {
  return (
    <FormControlLabel
      control={
        <Checkbox
          disableRipple
          sx={{
            paddingInline: '0',
          }}
          {...rest}
        />
      }
      label={label}
      sx={{
        gap: '6px',
      }}
    />
  );
}

export default UiCheckBox;
